import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_CONCLUDEAPPLICATION_FULFILLED = "FETCH_CONCLUDEAPPLICATION_FULFILLED";
export const FETCH_CONCLUDEAPPLICATION_REJECTED = "FETCH_CONCLUDEAPPLICATION_REJECTED";
export const FETCH_CONCLUDEAPPLICATION_PENDING = "FETCH_CONCLUDEAPPLICATION_PENDING";
export const RESET_CONCLUDEAPPLICATION = "RESET_CONCLUDEAPPLICATION"

export function concludeApplication(applicationId, reportData) {
    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_CONCLUDEAPPLICATION",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/conclude-application`,
                data: { applicationId, reportData },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetConcludeApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET_CONCLUDEAPPLICATION",
        });
    };
}




